import LazyLoad from 'vanilla-lazyload';

window.pageLazyLoad = new LazyLoad({
  threshold: 200,
});



// WEBPACK FOOTER //
// ./scripts/util/lazyLoad.js